/**
 * AI prediction vs. actual engagement comparison box.
 */
import { Crosshair } from "@phosphor-icons/react";

export function PredictionBox({ p, actual }) {
  const min = Math.max(0, Math.min(100, Number(p.score_min) || 0));
  const max = Math.max(min, Math.min(100, Number(p.score_max) || 0));
  const mid = (min + max) / 2;
  const tone = mid >= 60 ? "good" : mid >= 30 ? "mid" : "low";
  const color = tone === "good" ? "#00C853" : tone === "mid" ? "#FFCC00" : "#FF2A00";
  const label = tone === "good" ? "Alto potencial" : tone === "mid" ? "Potencial medio" : "Bajo potencial";

  // Hit/miss vs actual
  let verdict = null;
  if (typeof actual === "number" && actual > 0) {
    if (actual >= min && actual <= max) verdict = { txt: "En rango", color: "#00C853" };
    else if (actual > max) verdict = { txt: "Superó la predicción", color: "#00C853" };
    else verdict = { txt: "Por debajo de lo esperado", color: "#FF2A00" };
  }

  return (
    <div className="mt-4 border border-zinc-200 p-4" data-testid="prediction-box">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <Crosshair size={16} className="text-klein" />
          <div className="overline">Predicción IA</div>
        </div>
        <span className="text-[10px] uppercase tracking-[0.18em]" style={{ color }}>
          {label}
        </span>
      </div>

      <div className="flex items-baseline gap-3 mt-3">
        <div className="h-display text-3xl font-black tabular-nums" style={{ color }}>
          {min}–{max}
        </div>
        <div className="text-xs text-muted2">/100 score esperado</div>
      </div>

      {/* range bar */}
      <div className="relative h-2 bg-zinc-100 mt-3">
        <div
          className="absolute top-0 bottom-0"
          style={{ left: `${min}%`, width: `${Math.max(2, max - min)}%`, background: color }}
        />
        {typeof actual === "number" && actual > 0 && (
          <div
            className="absolute -top-1 -bottom-1 w-0.5 bg-ink"
            style={{ left: `calc(${Math.min(100, actual)}% - 1px)` }}
            title={`Score real: ${actual}`}
          />
        )}
      </div>
      <div className="flex justify-between text-[10px] text-muted2 mt-1 font-mono">
        <span>0</span>
        <span>50</span>
        <span>100</span>
      </div>

      {p.razonamiento && (
        <p className="text-xs text-muted2 mt-3 leading-relaxed">{p.razonamiento}</p>
      )}
      {verdict && (
        <div className="mt-2 text-[11px] font-medium" style={{ color: verdict.color }}>
          ● {verdict.txt} (real: {actual})
        </div>
      )}
    </div>
  );
}



// ----- Launch Plan -----
